export const getQueriesBestWords = (domain_id) => {
    return fetch(`/api/v1/domains/config/${domain_id}/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });
};
